<header
  class="header flex items-center justify-between z-[40] bg-[#1A1C1E] pr-4 pl-4"
  style="height: var(--layout-header-height)"
  [ngClass]="{
    'header--shrink':
      menuIsOpen &&
      screenSize !== 'xSmall' &&
      screenSize !== 'small' &&
      screenSize !== 'medium',
    'header--small': screenSize === 'xSmall',
    'header--large': screenSize !== 'xSmall',
  }"
>
  @if (screenSize !== "xSmall") {
    <app-menu-button></app-menu-button>
  }

  <section class="flex items-center gap-4">
    <!-- enable emergency mode -->
    @if (screenSize !== "xSmall" && !branchInfo?.is_emergency) {
      <ng-template [appHasAccess]="[Role.EnableEmergencyMode]">
        <button
          class="header__button header__logout-button w-full justify-center items-center gap-1 text-white !bg-danger pt-2 !mb-0"
          mat-button
          (click)="enableEmergencyMode()"
        >
          <mat-icon class="!ml-[-1px] -mt-1 text-white">gpp_maybe</mat-icon>
          {{ "branch.enableEmergencyMode" | translate }}
        </button>
      </ng-template>
    }

    <app-messaging-menu></app-messaging-menu>
    <ng-template [appHasAccess]="[Role.ViewReminder, Role.ViewReminderSelf]">
      <app-notifications-menu></app-notifications-menu>
    </ng-template>
    <app-setting-menu></app-setting-menu>
    <app-profile-menu></app-profile-menu>
  </section>
</header>
